'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dcAnalytics = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class; /*************************************************************************
                           * ADOBE CONFIDENTIAL
                           * ___________________
                           *
                           *  Copyright 2022 Adobe
                           *  All Rights Reserved.
                           *
                           * NOTICE:  All information contained herein is, and remains
                           * the property of Adobe and its suppliers, if any. The intellectual
                           * and technical concepts contained herein are proprietary to Adobe
                           * and its suppliers and are protected by all applicable intellectual
                           * property laws, including trade secret and copyright laws.
                           * Dissemination of this information or reproduction of this material
                           * is strictly forbidden unless prior written permission is obtained
                           * from Adobe.
                           **************************************************************************/

/* eslint no-underscore-dangle: 0, class-methods-use-this: 0, max-len: 0 */
/* global window, digitalData, PACKAGE_NAME, PACKAGE_VERSION */

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

var getFromStorage = function getFromStorage(key) {
    var storageType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'sessionStorage';

    try {
        var storage = void 0;
        if (storageType === 'sessionStorage') {
            storage = window.sessionStorage;
        } else if (storageType === 'localStorage') {
            storage = window.localStorage;
        }

        if (storage) {
            return storage.getItem(key) || '';
        }
    } catch (e) {
        // Not Logging it.
    }
    return '';
};

function isThirdPartyContext() {
    try {
        window.localStorage;
        return false;
    } catch (e) {
        return true;
    }
}

function promiseAllSettled(promises) {
    if (Promise && !Promise.allSettled) {
        return Promise.all(promises.map(function (promise) {
            return promise.then(function (value) {
                return { status: 'fulfilled', value: value };
            }).catch(function (reason) {
                return { status: 'rejected', reason: reason };
            });
        }));
    }
    return Promise.allSettled(promises);
}

var USER_TAG_NEW_USER = 'new_user';
var USER_TAG_RETURN_USER = 'return_user';
var USER_TAG_PAC_USER = 'pac_user';
var USER_TAG_SIGN_CENTRIC = 'sign_centric';
var USER_TAG_SIGN_ACTIVATED = 'sign_activated';
var USER_TAG_SIGN_LEARN_ENGAGED = 'sign_learn_engaged';
var USER_TAG_SIGN_KDE_ENABLED = 'sign_kde_enabled';
var USER_TAG_SIGN_MODERN_RS_ENABLED = 'sign_modern_rs_enabled';

var AnalyticsAPI = (_class = function () {
    function AnalyticsAPI() {
        var _this = this;

        _classCallCheck(this, AnalyticsAPI);

        this._events = [];

        this.getImage = function (url) {
            var img = new Image(1, 1);
            img.onload = function () {
                document.body.removeChild(img);
            };
            img.onerror = function () {
                document.body.removeChild(img);
            };
            img.src = url;
            img.style.display = 'none';
            document.body.appendChild(img);
        };

        this.triggerFacebookPixel = function (params) {
            var signedStatus = params.signedStatus,
                lang = params.lang,
                pageName = params.pageName;

            var isFacebookConsentGiven = window.adobePrivacy && window.adobePrivacy.activeCookieGroups().indexOf('C0004') > -1;
            if (isFacebookConsentGiven) {
                var src = 'https://www.facebook.com/tr?id=1772359959706965&ev=PageView&cd[userType]=' + signedStatus + '&cd[languageLocale]=' + lang + '&cd[pageName]=' + pageName;
                _this.getImage(src);
            }
        };
    }

    _createClass(AnalyticsAPI, [{
        key: 'initialize',
        value: function initialize(analyticsConfig, logging, auth, analytics, locale, theme) {
            if (!window._dc_analytics_initialized) {
                if (!window.dcWebSessionId) {
                    window.dcWebSessionId = _uuid2.default.v4();
                }
                this._config = analyticsConfig || AnalyticsAPI.defaultConfig;
                // configure analytics logging so that in a localhost they emit to console only,
                // but for all other environments, send to server only.
                // Use enableStream if so specified, otherwise use serverEnv to determine what to enable
                var options = {
                    enableStream: this._config.enableStream || (this._config.serverEnv === 'localdev' ? 'console' : 'server')
                };
                this._logger = logging.getLogger('AnalyticsAPI', options);
                this._auth = auth;
                this._locale = locale;
                this._theme = theme;
                window._dc_analytics_initialized = true;
                this._alloyOn = window.alloy_all !== undefined && Object.keys(window.alloy_all).length !== 0;
                analytics.configure(this._config, this.sendEvent);
            }
        }
    }, {
        key: 'initializeWithUser',
        value: function initializeWithUser(analyticsConfig, analytics) {
            var _this2 = this;

            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            if (!window._dc_analytics_initialized) {
                if (!window.dcWebSessionId) {
                    window.dcWebSessionId = _uuid2.default.v4();
                }
                this._config = analyticsConfig || AnalyticsAPI.defaultConfig;
                // configure analytics logging so that in a localhost they emit to console only,
                // but for all other environments, send to server only.
                // Use enableStream if so specified, otherwise use serverEnv to determine what to enable
                var loggingOptions = {
                    enableStream: this._config.enableStream || (this._config.serverEnv === 'localdev' ? 'console' : 'server')
                };
                this._logger = options.logging ? options.logging.getLogger('AnalyticsAPI', loggingOptions) : undefined;
                this._auth = options.auth;
                this._locale = options.locale;
                this._theme = options.theme;
                if (options.user) {
                    return promiseAllSettled([options.user.getIdentity(), options.user.getSubscriptions(), options.user.getPreferences('dcweb/sign_centric'), options.user.getPreferences('dcweb/sign')]).then(function (results) {
                        _this2._identity = results[0].status === 'fulfilled' ? results[0].value : undefined;
                        _this2._subscriptions = results[1].status === 'fulfilled' ? results[1].value : undefined;
                        _this2._signCentricPrefs = results[2].status === 'fulfilled' ? results[2].value : undefined;
                        _this2._signPrefs = results[3].status === 'fulfilled' ? results[3].value : undefined;
                        var intent = options.intent;
                        if (intent && intent.visitInfoPromise && intent.visitInfoPromise.promise) {
                            return intent.visitInfoPromise.promise.then(function () {
                                var userSubscription = _this2._subscriptions.subscriptions.find(function (s) {
                                    return s.status === 'Active' && s.level !== 'Free';
                                });
                                var userSubscriptionName = userSubscription ? userSubscription.name : 'Files';
                                var userSubscriptionLevel = userSubscription ? userSubscription.level : '';
                                return intent.getVisitInfo({
                                    userSubscription: userSubscriptionName,
                                    userSubscriptionLevel: userSubscriptionLevel
                                }).then(function (v) {
                                    _this2._visitInfo = v;
                                    window._dc_analytics_initialized = true;
                                    analytics.configure(_this2._config, _this2.sendEvent);
                                });
                            });
                        }
                        window._dc_analytics_initialized = true;
                        analytics.configure(_this2._config, _this2.sendEvent);
                    }).catch(function (err) {
                        window._dc_analytics_initialized = true;
                        analytics.configure(_this2._config, _this2.sendEvent);
                        throw err;
                    });
                } else {
                    window._dc_analytics_initialized = true;
                    analytics.configure(this._config, this.sendEvent);
                }
            }
            return Promise.resolve();
        }
    }, {
        key: 'setUser',
        value: function setUser(user, intent) {
            var _this3 = this;

            if (window._dc_analytics_initialized && user && !this._identity && !this._subscriptions) {
                user.getIdentity().then(function (identity) {
                    _this3._identity = identity;
                });
                user.getSubscriptions().then(function (subscriptions) {
                    _this3._subscriptions = subscriptions;
                    if (intent && intent.visitInfoPromise && intent.visitInfoPromise.promise) {
                        intent.visitInfoPromise.promise.then(function () {
                            var userSubscription = _this3._subscriptions.subscriptions.find(function (s) {
                                return s.status === 'Active' && s.level !== 'Free';
                            });
                            var userSubscriptionName = userSubscription ? userSubscription.name : 'Files';
                            var userSubscriptionLevel = userSubscription ? userSubscription.level : '';
                            intent.getVisitInfo({
                                userSubscription: userSubscriptionName,
                                userSubscriptionLevel: userSubscriptionLevel
                            }).then(function (v) {
                                _this3._visitInfo = v;
                            });
                        });
                    }
                });
                user.getPreferences('dcweb/sign_centric').then(function (prefs) {
                    _this3._signCentricPrefs = prefs;
                });
                user.getPreferences('dcweb/sign').then(function (prefs) {
                    _this3._signPrefs = prefs;
                });
            }
        }
    }, {
        key: 'setTheme',
        value: function setTheme(theme) {
            if (theme) {
                this._theme = theme;
            }
        }
    }, {
        key: 'setUserTags',
        value: function setUserTags(userTags) {
            if (userTags) {
                this._config.userTags = userTags;
            }
        }
    }, {
        key: 'setFloodgate',
        value: function setFloodgate(floodgate) {
            if (floodgate && !this._floodgate) {
                this._floodgate = floodgate;
            }
        }
    }, {
        key: 'setSophiaSurfaceData',
        value: function setSophiaSurfaceData(sophiaSurfaceData) {
            if (sophiaSurfaceData && !this._sophiaSurfaceData) {
                this._sophiaSurfaceData = sophiaSurfaceData;
            }
        }
    }, {
        key: '_getQueryParams',
        value: function _getQueryParams(search) {
            var dict = {};
            var i = void 0;
            var param = void 0;

            var params = (search || window.location.search).substr(1).split('&');

            if (params && params.length > 0) {
                for (i = 0; i < params.length; i += 1) {
                    param = params[i].split('=');
                    if (param.length === 2) {
                        dict[decodeURIComponent(param[0])] = decodeURIComponent(param[1].replace(/\+/g, ' '));
                    }
                }
            }
            return dict;
        }
    }, {
        key: '_getEventUrl',
        value: function _getEventUrl() {
            var eventUrl = '';
            if (this._config.saveURLInfo) {
                eventUrl = window.location.host + window.location.pathname;
                var eventUrlSplit = eventUrl.split('/');
                if (eventUrlSplit.includes('id') && eventUrlSplit.length > eventUrlSplit.indexOf('id') + 1) {
                    eventUrlSplit[eventUrlSplit.indexOf('id') + 1] = 'masked';
                    eventUrl = eventUrlSplit.join('/');
                }
                eventUrlSplit = eventUrl.split('/');
                if (eventUrlSplit.includes('documents') && eventUrlSplit.length > eventUrlSplit.indexOf('documents') + 2) {
                    eventUrlSplit[eventUrlSplit.indexOf('documents') + 2] = 'masked';
                    eventUrl = eventUrlSplit.join('/');
                }
            }
            return eventUrl;
        }
    }, {
        key: '_validateEvent',
        value: function _validateEvent(eventData) {
            return eventData.event && eventData.event.workflow !== undefined && eventData.event.subcategory !== undefined && eventData.event.type !== undefined;
        }
    }, {
        key: '_addFeatureFlags',
        value: function _addFeatureFlags(fields) {
            var _this4 = this;

            if (this._floodgate && this._config.flags) {
                var featureFlagsArray = this._floodgate.getArrayOfFlags().filter(function (f) {
                    return _this4._config.flags.some(function (flag) {
                        return f.startsWith(flag);
                    });
                });

                Object.assign(fields.user, {
                    feature_flags: featureFlagsArray.map(function (f) {
                        return f.replace(/^dc-web-/, '');
                    }).join(',')
                });
                Object.assign(fields.user, {
                    feature_flags_1: fields.user.feature_flags
                });
                if (fields.user.feature_flags.length > 255) {
                    var featureFlags = fields.user.feature_flags;
                    var fIndex = featureFlags.lastIndexOf(',', 255);
                    var featureFlags1 = featureFlags.slice(0, fIndex);
                    var featureFlags2 = featureFlags.slice(fIndex + 1);
                    Object.assign(fields.user, {
                        feature_flags_1: featureFlags1
                    });
                    Object.assign(fields.user, {
                        feature_flags_2: featureFlags2
                    });
                    if (featureFlags2.length > 255 && !this._dc_analytics_ff_warning) {
                        this._logger.warn('Feature flags exceed 255 characters limit');
                        this._dc_analytics_ff_warning = true;
                    }
                }
            }
        }
    }, {
        key: '_addDefaults',
        value: function _addDefaults(eventData) {
            var fields = {
                event: {
                    category: 'WEB',
                    guid: _uuid2.default.v4(),
                    session_guid: window.dcWebSessionId,
                    user_agent: window.navigator.userAgent,
                    url: this._getEventUrl()
                },
                user: {},
                content: {},
                source: {
                    name: 'dc-analytics-provider',
                    version: '2.11.5'
                },
                custom: {},
                session: {},
                verb: {}
            };

            fields.event.pagename = eventData.event.workflow;
            fields.event.pagename += eventData.event.subcategory ? ':' + eventData.event.subcategory : '';
            fields.event.pagename += eventData.event.type ? ':' + eventData.event.type : '';
            fields.event.pagename += eventData.event.subtype ? ':' + eventData.event.subtype : '';

            fields.event.user_locale = this._locale && this._locale.getRawLocale ? this._locale.getRawLocale() : '';

            // Add user profile fields if authenticated
            if (this._auth && this._auth.isSignedIn && this._identity && this._subscriptions) {
                var status = undefined;
                var subscriptions = this._subscriptions.subscriptions;
                var userServiceStatus = subscriptions.filter(function (o) {
                    return o.level !== 'Free' && o.status === 'Active';
                });
                if (userServiceStatus.length === 0) {
                    userServiceStatus = subscriptions.filter(function (o) {
                        return o.level === 'Free' && o.status === 'Active';
                    });
                }
                if (userServiceStatus.length > 0) {
                    status = userServiceStatus[0];
                }

                Object.assign(fields.event, {
                    user_guid: this._identity.user_id,
                    user_domain: this._identity.email.split('@')[1]
                });
                Object.assign(fields.user, {
                    serviceLevel: status ? status.level : '',
                    serviceCode: status ? status.name : '',
                    serviceStatus: status ? status.status : '',
                    subRef: status ? status.sub_ref : ''
                });
                if (window.adobeIMS && window.adobeIMS.getUserProfile) {
                    var profile = window.adobeIMS.getUserProfile();
                    if (profile) {
                        Object.assign(fields.user, {
                            ims_auth_id: profile.authId,
                            ims_user_id: profile.userId
                        });
                    }
                }
                Object.assign(fields.custom, {
                    'adb.user.attribute.subscriptionstatus': status ? status.name : ''
                });
                if (subscriptions.length > 1) {
                    Object.assign(fields.custom, {
                        'adb.user.attribute.multiplesubscriptionstatus': subscriptions.filter(function (o) {
                            return o.status === 'Active';
                        }).map(function (o) {
                            return o.name;
                        }).join(',')
                    });
                }
            }

            // Add user context if set
            var sessionContext = getFromStorage('session_context');
            if (sessionContext) {
                Object.assign(fields.custom, {
                    'adb.event.context.dcweb.sessioncontext': sessionContext
                });
            }

            // Add floodgate flags
            this._addFeatureFlags(fields);

            // Add sophia data
            if (this._sophiaSurfaceData && window.digitalData) {
                if (!window.digitalData.sophiaResponse || !window.digitalData.sophiaResponse.fromPage) {
                    window.digitalData.sophiaResponse = {
                        fromPage: []
                    };

                    var _loop = function _loop(k, v) {
                        if (v && v.containers) {
                            v.containers.forEach(function (c) {
                                window.digitalData.sophiaResponse.fromPage.push({
                                    actionBlockId: c.containerAnalyticsData.actionBlockId,
                                    campaignId: c.containerAnalyticsData.campaignId,
                                    containerId: c.containerAnalyticsData.containerId,
                                    controlGroupId: c.containerAnalyticsData.controlGroupId,
                                    treatmentId: c.containerAnalyticsData.treatmentId,
                                    variationId: c.containerAnalyticsData.variationId,
                                    surfaceid: k
                                });
                            });
                        }
                    };

                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = Object.entries(this._sophiaSurfaceData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var _ref = _step.value;

                            var _ref2 = _slicedToArray(_ref, 2);

                            var k = _ref2[0];
                            var v = _ref2[1];

                            _loop(k, v);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }

            return fields;
        }
    }, {
        key: '_addUserTag',
        value: function _addUserTag(eventData, tag) {
            if (!eventData) {
                return;
            }

            if (!eventData.user) {
                eventData.user = {};
            }

            if (!eventData.user.user_tags) {
                eventData.user.user_tags = [];
            }

            if (eventData.user.user_tags.indexOf(tag) === -1) {
                eventData.user.user_tags.push(tag);
            }
        }
    }, {
        key: '_addDefaults2',
        value: function _addDefaults2(id, eventData) {
            var queryParams = this._getQueryParams();
            var fields = {
                content: {},
                custom: {},
                event: {
                    id: id,
                    category: 'WEB',
                    time: Date.now()
                },
                session: {
                    start_page: getFromStorage('session_context'),
                    session_id: window.dcWebSessionId
                },
                source: {
                    user_agent: window.navigator.userAgent,
                    lang: window.navigator.language,
                    app_name: this._config.appName,
                    app_version: this._config.appVersion,
                    name: 'dc-analytics-provider',
                    version: '2.11.5',
                    url: this._getEventUrl(),
                    click_context: eventData.custom && eventData.custom['adb.event.context.dcweb.clickcontext'],
                    browser_width: window.screen && window.screen.width,
                    browser_height: window.screen && window.screen.height,
                    app_referrer: this._config.appReferrer,
                    tracking_id: this._config.trackingId,
                    app_tags: this._config.appTags && this._config.appTags.join(':'),
                    theme: this._theme ? this._theme.theme : undefined
                },
                user: {},
                verb: {}
            };

            fields.event.pagename = eventData.event.workflow;
            fields.event.pagename += eventData.event.subcategory ? ':' + eventData.event.subcategory : '';
            fields.event.pagename += eventData.event.type ? ':' + eventData.event.type : '';
            fields.event.pagename += eventData.event.subtype ? ':' + eventData.event.subtype : '';

            fields.user.locale = this._locale && this._locale.getRawLocale ? this._locale.getRawLocale() : '';

            var userTags = this._config.userTags ? this._config.userTags : [];
            if (eventData.user) {
                // Concat with tags set at config level and remove duplicatess
                var eventTags = userTags.concat(eventData.user.user_tags || []);
                eventData.user.user_tags = eventTags.filter(function (item, index) {
                    return eventTags.indexOf(item) === index;
                });
            } else {
                eventData.user = {
                    // Make a copy of userTags, otherwise the content change for
                    // eventData.user.user_tags could affect this._config.userTags.
                    user_tags: [].concat(_toConsumableArray(userTags))
                };
            }

            var status = undefined;
            var subscriptions = [];
            if (this._auth && this._auth.isSignedIn && this._identity && this._subscriptions) {
                subscriptions = this._subscriptions.subscriptions;
                var userServiceStatus = subscriptions.filter(function (o) {
                    return o.level !== 'Free' && o.status === 'Active';
                });
                if (userServiceStatus.length === 0) {
                    userServiceStatus = subscriptions.filter(function (o) {
                        return o.level === 'Free' && o.status === 'Active';
                    });
                }
                if (userServiceStatus.length > 0) {
                    status = userServiceStatus[0];
                }
            }

            // "adobeid" (type 1), "enterprise" (type 2) or "federated" (type 3) or "business" (type 2e)
            var category = undefined;
            if (this._auth && this._auth.isSignedIn && this._identity) {
                category = this._identity.category;
            }

            // check for user UI type : Sign centric or Default
            var signCentricSubscription = subscriptions.find(function (s) {
                return s.status === 'Active' && s.name === 'ESign' && s.subscription_params && s.subscription_params.SignExperience === 'DCSignCentric';
            });
            if (signCentricSubscription) {
                this._addUserTag(eventData, USER_TAG_SIGN_CENTRIC);
            }

            if (this._signCentricPrefs) {
                // add sign_activated into user_tags accordingly
                if (this._signCentricPrefs.returning_user) {
                    this._addUserTag(eventData, USER_TAG_SIGN_ACTIVATED);
                }

                // add learn_engaged into user_tags accordingly
                if (this._signCentricPrefs.learn_engaged) {
                    this._addUserTag(eventData, USER_TAG_SIGN_LEARN_ENGAGED);
                }

                // add key date extraction tag into user_tags accordingly
                if (this._signCentricPrefs.kde_enabled) {
                    this._addUserTag(eventData, USER_TAG_SIGN_KDE_ENABLED);
                }
            }
            if (this._signPrefs) {
                // add modern request signatures tag into user_tags accordingly
                if (this._signPrefs.modern_rs_enabled) {
                    this._addUserTag(eventData, USER_TAG_SIGN_MODERN_RS_ENABLED);
                }
            }

            // add new_user or return_user into user_tags accordingly if the user is signed in
            if (this._auth && this._auth.isSignedIn && this._identity && this._identity.first_time) {
                if (this._identity.first_time.dex_web_app) {
                    this._addUserTag(eventData, USER_TAG_NEW_USER);
                } else {
                    this._addUserTag(eventData, USER_TAG_RETURN_USER);
                }
            }

            // add pac_user into user_tags accordingly if the user account is incomplete
            if (this._auth && this._auth.isSignedIn && this._auth.isIncompleteAccount()) {
                this._addUserTag(eventData, USER_TAG_PAC_USER);
            }

            Object.assign(fields.user, {
                id: this._identity && this._identity.user_id || queryParams.anonUserUUID || getFromStorage('anonUserUUID', 'localStorage'),
                is_authenticated: this._auth && this._auth.isSignedIn,
                user_domain: this._identity && this._identity.email.split('@')[1],
                category: category,
                service_level: status ? status.level : '',
                service_code: status ? status.name : '',
                service_codes: subscriptions.filter(function (o) {
                    return o.status === 'Active';
                }).map(function (o) {
                    return o.name;
                }).join(','),
                subscriptions: subscriptions.filter(function (o) {
                    return o.status === 'Active';
                }).map(function (o) {
                    return o.name + ':' + o.level;
                }).join(','),
                service_status: status ? status.status : '',
                sub_ref: status ? status.sub_ref : ''
            });

            if (this._visitInfo) {
                Object.assign(fields.user, {
                    visit_count: this._visitInfo.visit_count
                });
            }

            // Add feature flags
            this._addFeatureFlags(fields);

            if (this._auth && this._auth.isSignedIn && window.adobeIMS && window.adobeIMS.getUserProfile) {
                var profile = window.adobeIMS.getUserProfile();
                if (profile) {
                    Object.assign(fields.user, {
                        ims_auth_id: profile.authId,
                        ims_user_id: profile.userId
                    });
                }
            }

            // Add sophia data
            if (this._sophiaSurfaceData && window.digitalData) {
                if (!window.digitalData.sophiaResponse || !window.digitalData.sophiaResponse.fromPage) {
                    window.digitalData.sophiaResponse = {
                        fromPage: []
                    };

                    var _loop2 = function _loop2(k, v) {
                        if (v && v.containers) {
                            v.containers.forEach(function (c) {
                                window.digitalData.sophiaResponse.fromPage.push({
                                    actionBlockId: c.containerAnalyticsData.actionBlockId,
                                    campaignId: c.containerAnalyticsData.campaignId,
                                    containerId: c.containerAnalyticsData.containerId,
                                    controlGroupId: c.containerAnalyticsData.controlGroupId,
                                    treatmentId: c.containerAnalyticsData.treatmentId,
                                    variationId: c.containerAnalyticsData.variationId,
                                    surfaceid: k
                                });
                            });
                        }
                    };

                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = Object.entries(this._sophiaSurfaceData)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var _ref3 = _step2.value;

                            var _ref4 = _slicedToArray(_ref3, 2);

                            var k = _ref4[0];
                            var v = _ref4[1];

                            _loop2(k, v);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            }

            return fields;
        }
    }, {
        key: '_createDigitalData',
        value: function _createDigitalData(data, data2) {
            if (!window.digitalData || Object.keys(window.digitalData).length === 0) {
                this._logger.warn('digitalData is not defined or valid');
                return;
            }

            var breadcrumbs = window.location.pathname.split('/');
            if (breadcrumbs.length > 0 && breadcrumbs[0] === '') {
                breadcrumbs = breadcrumbs.slice(1);
            }

            digitalData._set('page.pageInfo.breadCrumbs', breadcrumbs);
            digitalData._set('page.pageInfo.siteSection', data.source.name);
            digitalData._set('primaryEvent.eventInfo.id', data.event.guid);
            digitalData._set('primaryEvent.eventInfo.eventName', data.event.pagename);
            digitalData._set('primaryEvent.category.primaryCategory', data.event.workflow);
            digitalData._set('primaryEvent.category.subCategory', data.event.subcategory);
            digitalData._set('primaryEvent.eventInfo.type', data.event.type);
            digitalData._set('primaryEvent.eventInfo.subtype', data.event.subtype);
            digitalData._set('primaryComponent.componentInfo.name', data.source.name);
            digitalData._set('primaryComponent.componentInfo.version', data.source.version);

            Object.keys(data.event).forEach(function (property) {
                digitalData._set('dcweb.event.' + property, data.event[property]);
            });
            Object.keys(data.source).forEach(function (property) {
                digitalData._set('dcweb.source.' + property, data.source[property]);
            });
            Object.keys(data.content).forEach(function (property) {
                digitalData._set('dcweb.content.' + property, data.content[property]);
            });
            Object.keys(data.user).forEach(function (property) {
                digitalData._set('dcweb.user.' + property, data.user[property]);
            });
            Object.keys(data.custom).forEach(function (property) {
                digitalData._set('dcweb.custom.' + property, data.custom[property]);
            });

            Object.keys(data2.event).forEach(function (property) {
                digitalData._set('dcweb2.event.' + property, data2.event[property]);
            });
            Object.keys(data2.source).forEach(function (property) {
                digitalData._set('dcweb2.source.' + property, data2.source[property]);
            });
            Object.keys(data2.content).forEach(function (property) {
                digitalData._set('dcweb2.content.' + property, data2.content[property]);
            });
            Object.keys(data2.user).forEach(function (property) {
                digitalData._set('dcweb2.user.' + property, data2.user[property]);
            });
            Object.keys(data2.custom).forEach(function (property) {
                digitalData._set('dcweb2.custom.' + property, data2.custom[property]);
            });
            Object.keys(data2.session).forEach(function (property) {
                digitalData._set('dcweb2.session.' + property, data2.session[property]);
            });
            Object.keys(data2.verb).forEach(function (property) {
                digitalData._set('dcweb2.verb.' + property, data2.verb[property]);
            });
        }
    }, {
        key: '_sendDigitalData',
        value: function _sendDigitalData(options) {
            if (!window.digitalData || Object.keys(window.digitalData).length === 0 || !window._satellite || Object.keys(window._satellite).length === 0) {
                this._logger.warn('digitalData and _satellite must be defined and valid');
                return;
            }

            var sendAnalytics = window._satellite.track;
            if (isThirdPartyContext() && this._config.sendAnalyticsCallback && typeof this._config.sendAnalyticsCallback === 'function') {
                sendAnalytics = this._config.sendAnalyticsCallback;
            }

            if (!options.pageLoadEvent) {
                sendAnalytics('event', {
                    // Send as a parameter a snapshot of the data layer at this point in time.
                    // Note: if this is not set, we will handle take a snapshot within
                    // the _satellite.track handler.
                    digitalData: digitalData._snapshot()
                });
            } else {
                sendAnalytics('state');
            }
        }
    }, {
        key: '_createAlloyData',
        value: function _createAlloyData(data, data2) {
            if (!this._alloyOn) {
                this._logger.warn('Alloy is not defined or valid');
                return;
            }

            var breadcrumbs = window.location.pathname.split('/');
            if (breadcrumbs.length > 0 && breadcrumbs[0] === '') {
                breadcrumbs = breadcrumbs.slice(1);
            }
            var customDigitalData = {
                'page.pageInfo.breadCrumbs': breadcrumbs,
                'page.pageInfo.siteSection': data.source.name,
                'primaryEvent.eventInfo.id': data.event.guid,
                'primaryEvent.eventInfo.eventName': data.event.pagename,
                'primaryEvent.category.primaryCategory': data.event.workflow,
                'primaryEvent.category.subCategory': data.event.subcategory,
                'primaryEvent.eventInfo.type': data.event.type,
                'primaryEvent.eventInfo.subtype': data.event.subtype,
                'primaryComponent.componentInfo.name': data.source.name,
                'primaryComponent.componentInfo.version': data.source.version
            };

            Object.keys(data.event).forEach(function (property) {
                Object.assign(customDigitalData, _defineProperty({}, 'dcweb.event.' + property, data.event[property]));
            });
            Object.keys(data.source).forEach(function (property) {
                Object.assign(customDigitalData, _defineProperty({}, 'dcweb.source.' + property, data.source[property]));
            });
            Object.keys(data.content).forEach(function (property) {
                Object.assign(customDigitalData, _defineProperty({}, 'dcweb.content.' + property, data.content[property]));
            });
            Object.keys(data.user).forEach(function (property) {
                Object.assign(customDigitalData, _defineProperty({}, 'dcweb.user.' + property, data.user[property]));
            });
            Object.keys(data.custom).forEach(function (property) {
                Object.assign(customDigitalData, _defineProperty({}, 'dcweb.custom.' + property, data.custom[property]));
            });

            Object.keys(data2.event).forEach(function (property) {
                Object.assign(customDigitalData, _defineProperty({}, 'dcweb2.event.' + property, data2.event[property]));
            });
            Object.keys(data2.source).forEach(function (property) {
                Object.assign(customDigitalData, _defineProperty({}, 'dcweb2.source.' + property, data2.source[property]));
            });
            Object.keys(data2.content).forEach(function (property) {
                Object.assign(customDigitalData, _defineProperty({}, 'dcweb2.content.' + property, data2.content[property]));
            });
            Object.keys(data2.user).forEach(function (property) {
                Object.assign(customDigitalData, _defineProperty({}, 'dcweb2.user.' + property, data2.user[property]));
            });
            Object.keys(data2.custom).forEach(function (property) {
                Object.assign(customDigitalData, _defineProperty({}, 'dcweb2.custom.' + property, data2.custom[property]));
            });
            Object.keys(data2.session).forEach(function (property) {
                Object.assign(customDigitalData, _defineProperty({}, 'dcweb2.session.' + property, data2.session[property]));
            });
            Object.keys(data2.verb).forEach(function (property) {
                Object.assign(customDigitalData, _defineProperty({}, 'dcweb2.verb.' + property, data2.verb[property]));
            });

            return customDigitalData;
        }
    }, {
        key: '_sendAlloyData',
        value: function _sendAlloyData(options, customDigitalData) {
            if (!this._alloyOn || !window._satellite || Object.keys(window._satellite).length === 0) {
                this._logger.warn('alloy and satellite must be defined and valid');
                return;
            }

            var sendAnalytics = window._satellite.track;
            if (isThirdPartyContext() && this._config.sendAnalyticsCallback && typeof this._config.sendAnalyticsCallback === 'function') {
                sendAnalytics = this._config.sendAnalyticsCallback;
            }
            if (!options.pageLoadEvent) {
                sendAnalytics('event', {
                    xdm: {},
                    data: {
                        eventType: 'web.webinteraction.linkClicks',
                        web: {
                            webInteraction: {
                                name: customDigitalData['primaryEvent.eventInfo.eventName'],
                                URL: '',
                                linkClicks: {
                                    value: 1
                                },
                                type: 'other'
                            }
                        },
                        _adobe_corpnew: {
                            digitalData: customDigitalData,
                            sdm: {}
                        }
                    }
                });
            } else {
                // for page load events (state changes, view changes, modal loads, etc.)
                // for Frictionless this is taken care of A.com as they will be loading the alloy script
                this._logger.warn('Trying to send state change events via alloy - not supported for yet');
            }
        }
    }, {
        key: '_clearDigitalData',
        value: function _clearDigitalData(data, data2) {
            if (!window.digitalData || Object.keys(window.digitalData).length === 0) {
                this._logger.warn('digitalData is not defined or valid');
                return;
            }

            digitalData._delete('page.pageInfo.breadCrumbs');
            digitalData._delete('page.pageInfo.siteSection');
            digitalData._delete('primaryEvent.eventInfo.id');
            digitalData._delete('primaryEvent.eventInfo.eventName');
            digitalData._delete('primaryEvent.category.primaryCategory');
            digitalData._delete('primaryEvent.category.subCategory');
            digitalData._delete('primaryEvent.eventInfo.type');
            digitalData._delete('primaryEvent.eventInfo.subtype');
            digitalData._delete('primaryComponent.componentInfo.name');
            digitalData._delete('primaryComponent.componentInfo.version');

            Object.keys(data.event).forEach(function (property) {
                digitalData._delete('dcweb.event.' + property);
            });
            Object.keys(data.source).forEach(function (property) {
                digitalData._delete('dcweb.source.' + property);
            });
            Object.keys(data.content).forEach(function (property) {
                digitalData._delete('dcweb.content.' + property);
            });
            Object.keys(data.user).forEach(function (property) {
                digitalData._delete('dcweb.user.' + property);
            });
            Object.keys(data.custom).forEach(function (property) {
                digitalData._delete('dcweb.custom.' + property);
            });

            Object.keys(data2.event).forEach(function (property) {
                digitalData._delete('dcweb2.event.' + property);
            });
            Object.keys(data2.source).forEach(function (property) {
                digitalData._delete('dcweb2.source.' + property);
            });
            Object.keys(data2.content).forEach(function (property) {
                digitalData._delete('dcweb2.content.' + property);
            });
            Object.keys(data2.user).forEach(function (property) {
                digitalData._delete('dcweb2.user.' + property);
            });
            Object.keys(data2.custom).forEach(function (property) {
                digitalData._delete('dcweb2.custom.' + property);
            });
            Object.keys(data2.session).forEach(function (property) {
                digitalData._delete('dcweb2.session.' + property);
            });
            Object.keys(data2.verb).forEach(function (property) {
                digitalData._delete('dcweb2.verb.' + property);
            });
        }
    }, {
        key: 'sendEvent',
        value: function sendEvent(eventData, opts) {
            var _this5 = this;

            // eslint-disable-next-line no-param-reassign
            var options = opts || {};

            // Initialize if not already done yet
            this.initialize();

            var isAAOptedOut = window.adobe && window.adobe.optIn && window.adobe.optIn.isApproved && !window.adobe.optIn.isApproved('aa');

            // Per legal: We can still send data to splunk even if AA is opted out
            // This is because usage of splunk logs is limited to operationalization
            // of the service/application
            options.enableLogging = this._config.enableLogging && options.enableLogging !== false;
            options.enableAnalytics = this._config.enableAnalytics && options.enableAnalytics !== false && !isAAOptedOut;

            // Check if eventData is valid
            if (!this._validateEvent(eventData)) {
                var err = new Error('Invalid eventData');
                this._logger.warn('%o', err);
                return Promise.reject(err);
            }

            // Add default data
            var fields = this._addDefaults(eventData);
            var fields2 = this._addDefaults2(fields.event.guid, eventData);

            // Add eventData
            var allowedCategories = Object.keys(this._config.allowedKeys);
            Object.entries(eventData).forEach(function (_ref5) {
                var _ref6 = _slicedToArray(_ref5, 2),
                    categoryKey = _ref6[0],
                    categoryValue = _ref6[1];

                if (allowedCategories.includes(categoryKey)) {
                    Object.entries(categoryValue).forEach(function (_ref7) {
                        var _ref8 = _slicedToArray(_ref7, 2),
                            dataKey = _ref8[0],
                            dataValue = _ref8[1];

                        if (_this5._config.allowedKeys[categoryKey][0] === '*' || _this5._config.allowedKeys[categoryKey].includes(dataKey)) {
                            if (fields[categoryKey]) {
                                fields[categoryKey][dataKey] = dataValue;
                            }
                            if (fields2[categoryKey]) {
                                fields2[categoryKey][dataKey] = dataValue;
                            }
                        }
                    });
                }
            });

            if (options.enableAnalytics) {
                if (this._alloyOn) {
                    this._logger.info('Alloy available, and being used for Analytics');
                    var customDigitalData = this._createAlloyData(fields, fields2);
                    this._sendAlloyData(options, customDigitalData);
                } else {
                    this._createDigitalData(fields, fields2);
                    this._sendDigitalData(options);
                    this._clearDigitalData(fields, fields2);
                }
            }

            if (options.enableLogging) {
                this._events.push({
                    fields: fields,
                    fields2: fields2
                });
                if (!options.queueEvent) {
                    this._events.forEach(function (e) {
                        var ev = {};
                        Object.keys(e.fields).forEach(function (cat) {
                            Object.keys(e.fields[cat]).forEach(function (k) {
                                ev[cat + '.' + k] = e.fields[cat][k];
                            });
                        });
                        Object.keys(e.fields2).forEach(function (cat) {
                            Object.keys(e.fields2[cat]).forEach(function (k) {
                                ev['fields2.' + cat + '.' + k] = e.fields2[cat][k];
                            });
                        });
                        _this5._logger.emit('sendEvent', ev);
                    });
                    this._events.length = 0;
                }
            }

            return Promise.resolve(fields);
        }

        /**
         * Returns a promise which resolves when the provider is ready
         *
         */

    }, {
        key: 'ready',
        value: function ready() {
            return Promise.resolve(this);
        }
    }]);

    return AnalyticsAPI;
}(), (_applyDecoratedDescriptor(_class.prototype, 'initialize', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'initialize'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'initializeWithUser', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'initializeWithUser'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setUser', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'setUser'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setTheme', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'setTheme'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setUserTags', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'setUserTags'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setFloodgate', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'setFloodgate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setSophiaSurfaceData', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'setSophiaSurfaceData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_getQueryParams', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, '_getQueryParams'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_getEventUrl', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, '_getEventUrl'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_validateEvent', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, '_validateEvent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_addFeatureFlags', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, '_addFeatureFlags'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_addDefaults', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, '_addDefaults'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_addUserTag', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, '_addUserTag'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_addDefaults2', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, '_addDefaults2'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_createDigitalData', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, '_createDigitalData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_sendDigitalData', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, '_sendDigitalData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_createAlloyData', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, '_createAlloyData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_clearDigitalData', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, '_clearDigitalData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'sendEvent', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'sendEvent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'ready', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'ready'), _class.prototype)), _class);


AnalyticsAPI.defaultConfig = {
    allowedKeys: {
        event: ['workflow', 'subcategory', 'type', 'subtype', 'value'],
        source: ['name', 'version'],
        content: ['*'],
        custom: ['*'],
        verb: ['*'],
        session: ['request_id']
    },
    enableAnalytics: true,
    enableLogging: true,
    saveURLInfo: true,
    flags: [],
    appName: '',
    appVersion: '',
    appTags: [],
    appReferrer: '',
    trackingId: '',
    enableStream: undefined,
    userTags: [],
    sendAnalyticsCallback: undefined
};

var dcAnalytics = exports.dcAnalytics = new AnalyticsAPI();
exports.default = AnalyticsAPI;
